var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22183 19.7782C8.51759 24.0739 15.4824 24.0739 19.7782 19.7782C24.0739 15.4824 24.0739 8.51759 19.7782 4.22183C15.4824 -0.0739418 8.51759 -0.0739418 4.22183 4.22183C-0.0739418 8.51759 -0.0739418 15.4824 4.22183 19.7782Z",
    fill: "#454551"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9801 13.5357L8.86879 16.647C7.8317 17.684 6.27606 16.1284 7.31315 15.0913L10.4244 11.9801L7.37298 8.92862C6.33589 7.89153 7.89153 6.33589 8.92862 7.37298L11.9801 10.4244L15.0913 7.31315C16.1284 6.27606 17.684 7.8317 16.647 8.86879L13.5357 11.9801L16.5871 15.0315C17.6242 16.0686 16.0686 17.6242 15.0315 16.5871L11.9801 13.5357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFill);
export default __webpack_public_path__ + "static/media/closeFill.276ba60168c1a7568b2356ae816e2c73.svg";
export { ForwardRef as ReactComponent };